import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useFlags } from "launchdarkly-react-client-sdk";
import useLanguageChange from "../../../hooks/useLanguageChange";
import { isSilentObserverAvailable } from "../../../shared/function";
import {
    checkIsAudioPermissionBlock,
    handleToggleAudio,
    micButtonLDFlagStatus,
    requestMicPermissionToTheAgent,
} from "../../Twilio/AudioCall/AudioCallUtils";
import { LogFirebase } from "../../../services/firestore";
import { GLOBAL_MEETING_DATA } from "../../../constants/PublicVariables";
import { setIsAudioButtonClickDisable } from "../../../reducers/common-reducer";
import { handleStartStopAudioPlaySound } from "../Room/roomFunction";

const Audiobutton = () => {
    const dispatch = useDispatch();
    const { isRemoteParticipantJoined, isAudioButtonClickDisable } = useSelector((state) => state.commonReducer);
    const { startLocalAudio } = useSelector((state) => state.twilioEvents);
    const ldFlags = useFlags();
    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const checkAudioEnable = useMemo(() => {
        return isRemoteParticipantJoined && startLocalAudio === true;
    }, [isRemoteParticipantJoined, startLocalAudio]);

    const toggleAudio = () => {
        LogFirebase("Audio", "audio_button", "clicked");
        handleStartStopAudioPlaySound(!startLocalAudio); // handle heptic feedback
        if (requestMicPermissionToTheAgent()) return;
        dispatch(setIsAudioButtonClickDisable(true)); // disable audio button(button click variable)
        if (checkIsAudioPermissionBlock()) return;
        handleToggleAudio();
    };

    return (
        <>
            {!isSilentObserverAvailable() && (
                <div className='action-button' data-testid='audio-button-component'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className={clsx("call-action-btn", checkAudioEnable ? "active" : "")}
                            onClick={toggleAudio}
                            disabled={!isRemoteParticipantJoined || !micButtonLDFlagStatus(ldFlags?.micButtonStatus) || isAudioButtonClickDisable}
                            data-testid='audio-button'
                        >
                            <span className='action-button-icon'>
                                <span className={clsx("for-icon", startLocalAudio === true ? "icon-unmute" : "icon-mute")}></span>
                            </span>
                            <span className='for-text'>{startLocalAudio === true ? localisedValues["mute"] : localisedValues["muted"]}</span>
                        </button>
                        {!micButtonLDFlagStatus(ldFlags?.micButtonStatus) && (
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    {GLOBAL_MEETING_DATA.isAgent && <p>{localisedValues["audio_disabled_by_admin"]}</p>}
                                    {GLOBAL_MEETING_DATA.isGuest && <p>{localisedValues["audio_disabled"]}</p>}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Audiobutton;
